import type { NextPage } from 'next';
import { useTranslation } from 'next-i18next';
import Layout from 'src/components/common/layout/Layout';
import RegisterForm from 'src/components/forms/register/RegisterForm';
import { getStaticPaths, makeStaticProps } from 'src/utils/helpers/getStatic';

const getStaticProps = makeStaticProps(['register']);
export { getStaticPaths, getStaticProps };

const RegisterPage: NextPage = () => {
    const { t } = useTranslation('register');

    return (
        <Layout backUrl="/" bottombar={false} title={t('page-title')}>
            <RegisterForm />
        </Layout>
    );
};

export default RegisterPage;
